import { cn } from "src/lib/utils"
import { SlotProps } from "input-otp"

export function Slot(props) {
    return (
      <div
        className={cn(
          'relative w-10 h-14 text-[2rem]',
          'flex items-center justify-center',
          'transition-all duration-300',
          ' border rounded-md',
          "group-hover:border-primary",
        //   'group-hover:border-primary-1 group-focus-within:border-primary-1',
          'outline outline-0 outline-primary-1',
          { 'outline-4 outline-primary': props.isActive },
        )}
      >
        {props.char !== null && <div>{props.char}</div>}
        {props.hasFakeCaret && <FakeCaret />}
      </div>
    )
  }
   
  // You can emulate a fake textbox caret!
  export function FakeCaret() {
    return (
      <div className="absolute pointer-events-none inset-0 flex items-center justify-center animate-caret-blink">
        <div className="w-px h-8 bg-white" />
      </div>
    )
  }
   
  // Inspired by Stripe's MFA input.
  export function FakeDash() {
    return (
      <div className="flex w-2 justify-center items-center"> - </div>
    )
  }

  
  export const DashSlotGroup = ({ slots, start, end }) => (
    <>
      {slots?.slice(start, end).map((slot, idx) => (
        <Slot key={idx} {...slot}/>
      ))}
      {end != slots?.length && <FakeDash /> }
    </>
  );